import React, { useContext, useEffect, useState } from "react";
import _ from "lodash";
import MultiSelectAll from "../components/MultiSelectAll";
import { useHistory } from "react-router-dom";
import { AppContext } from "../../../../Context/AppContext";
import AppSettings from "../../../../Settings/AppSettings";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import Utils from "../../../../Common/Utils";
import LongDescription from "../components/LongDescription";
import ProductImages from "../components/ProductImagesNew";
import Label from "../../../Common/components/Label";
import { toast } from "react-toastify";
import SkeletonElement from "../../Category/Shimmer/SkeletonElement";
import GMSBorderlessButton from "../../../Common/components/GMSBorderlessButton";
import { BackArrowIcon } from "assests/GmsIcons";
import { NAME_INFO } from "../ProductConstants";
import RulesReRun from "./RulesRerun";
import {useLocation} from 'react-router-dom'


function CreateEditProduct({ productid }) {
  const history = useHistory();
  const appData = useContext(AppContext);
  const location = useLocation()

  const industryId =
    appData.get_selected_industry() && appData.get_selected_industry().id;
  const partyId = JSON.parse(localStorage.getItem("current_party_id"));
  const api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const channelKey = appData?.channelKey ?? '';
  const [initialState, setinitialState] = useState({});
  const [initialStateCopy, setinitialStateCopy] = useState(initialState);
  const [selectedAttvalues, setSelectedAttvalues] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [productDescriptionAvailable, setProductDescriptionAvailable] =
    useState(null);
  const [disableButton, setDisableButton] = useState(true);
  const [productImages, setProductImages] = useState([]);
  const [longDescription, setLongDescription] = useState(null);
  const [initialDescriptionAndImages, setInitialDescriptionAndImages] = useState({description: null, images: []})
  
  
  const [isSaving, setIsSaving] = useState(false);

  const [attributeList, setAttributeList] = useState([]);
  let [selected_Category, setSelected_Category] = React.useState({
    id: null,
    name: "",
  });
  const [formSubmitted, setFormSubmitted] = useState(false);

  const [product_load_indicator, setProduct_load_indicator] = useState({
    loading: false,
    error: false,
    message: null,
  });

  const [save_indicator, setSave_indicator] = useState({
    loading: false,
    error: false,
    message: null,
  });

  const [rulesRerun, setRulesRerun] = useState(false);
  const [runMaster, setRunMaster] = useState(false);

  const loadCategoryList = async () => {
    try {
      setProduct_load_indicator((prev) => {
        return { ...prev, loading: true };
      });
      let res = await ServiceWrapper.doGet(
        `${api_base_url}industry/${industryId}/category`,
        null,
        null,
        AuthManager.getGmsToken()
      );
      if (!res.errorfound) {
        setCategoryList(res.data.data);
        setProduct_load_indicator((prev) => {
          return { ...prev, loading: false };
        });
      } else {
        setProduct_load_indicator((prev) => {
          return { ...prev, loading: false };
        });
      }
    } catch (error) {
      setProduct_load_indicator((prev) => {
        return { ...prev, loading: false };
      });
    }
  };

  useEffect(() => {
    loadCategoryList();
  }, []);

  async function load_Product_details_by_id() {
    setProduct_load_indicator({
      loading: true,
      error: false,
      message: "Loading Product Details",
    });

    let res = await ServiceWrapper.doGet(
      `${api_base_url}product/details/${productid} `,
      null,
      null,
      AuthManager.getGmsToken()
    );

    setProductDescriptionAvailable(res?.data?.data?.long_description);

    if (!res.errorfound) {
      if (res?.data?.done === true) {
        var rdata = res.data.data;
        setProductDescriptionAvailable(rdata.long_description);
        var avalues = [];
        rdata.attr_vals.forEach((attr) => {
          attr.attr_value.forEach((av) => {
            avalues.push({
              label: av.value,
              value: av.val_id,
              id: av.val_id,
              // value_id: av.val_id,
              attributeid: attr.attr_id,
              // attr_id: attr.attr_id,
            });
          });
        });

        rdata.product_attr_values = {};
        rdata.long_description = Utils.isUndefinedOrNull(rdata.long_description)
          ? false
          : rdata.long_description;
        rdata.product_attr_values.add_attr_values = avalues;
        rdata.product_attr_values.delete_attr_values = [];
        rdata.product_attr_values.add_attr_values = _.sortBy(
          rdata.product_attr_values.add_attr_values,
          "label"
        );
        rdata.product_attr_values_existing =
          rdata.product_attr_values.add_attr_values;
        setinitialState(rdata);
        setinitialStateCopy(rdata);
        setSelected_Category({ id: rdata.category_id, name: "" });
        setProduct_load_indicator({
          loading: false,
          error: false,
          message: "Product Loaded",
        });
      } else {
        setProduct_load_indicator({
          loading: false,
          error: true,
          message: res.data.message,
        });
      }
    } else {
      setProduct_load_indicator({
        loading: false,
        error: true,
        message: "Error Loading Product Details",
      });
    }
  }

  function get_changes_to_be_saved() {
    var temp = JSON.parse(JSON.stringify(initialState));

    var new_add_set = [];
    temp.product_attr_values.add_attr_values.forEach((aval) => {
      var exists0 = temp.product_attr_values_existing.filter(
        (i) => i.attributeid === aval.attributeid && i.value === aval.value
      );

      var existed_in_original_List = exists0.length > 0;
      if (!existed_in_original_List) {
        new_add_set.push(aval);
      }
    });

    temp.product_attr_values.add_attr_values = new_add_set;
    return temp;
  }

  async function handleSaveEdit() {
    if (isSaving) return;
    setIsSaving(true); 
    
    //appData.reset();
    setSave_indicator({
      loading: true,
      error: false,
      message: "Saving Changes",
    });
    setFormSubmitted(true);

    let url;
    if (productid === "0") {
      url = `product/create`;
    } else {
      url = `product/edit/${productid}`;
    }
    var latest_changes = get_changes_to_be_saved();

    if (
      !latest_changes?.min_ad_price ||
      isNaN(latest_changes.min_ad_price) ||
      latest_changes.min_ad_price <= 0
    ) {
      toast.error("min_ad_price should be greater than 0.0");
      setIsSaving(false);
      return;
    }

    let productImagesGlobal = appData.productImagesGlobal;

    const finalData = {
      ...latest_changes,
      stage_item_id: 1,
      category_id: selected_Category && selected_Category.id,
      party_id: partyId,
      // product_images: productImagesGlobal,
      long_description_data: {
        description: appData.longDescriptionGlobal,
        isRichText: true,
      },
    };
    const final_url = `${api_base_url}${url}`;
    const formData = new FormData();
    if (productImagesGlobal.length > 0) {
      productImagesGlobal.forEach((file) => {
        formData.append("product_images", file, file.name);
      });

      if (productImagesGlobal[0] !== null) {
        productImagesGlobal.forEach((file) => {
          formData.append("product_images", file, file.name);
        });
      } 

      formData.append(
        "product_images_existing_count",
        productImagesGlobal.length.toString()
      );
    }
    

    formData.append("data", JSON.stringify(finalData));
    const res = await ServiceWrapper.doPost(
      final_url,
      formData,
      null,
      AuthManager.getGmsToken(),
      true
    );
    setIsSaving(false);
    
    if (!res.errorfound) {
      if (res.data.done) {
        if (productid === "0") {
          setTimeout(() => {
            history.replace({
              pathname: `/gms/product/edit/${res.data.id}`,
            });
          }, [1000]);
        } else {
          appData.setProductImagesGlobal([]);
          appData.setLongDescriptionGlobal(null);
          setinitialStateCopy(latest_changes);
        }
        toast.success(res.data.message+"\n Rules added to Queue");
        // if (productid !== "0") {
        // setRulesRerun(true);
        // }

        setTimeout(() => {
          setSave_indicator({
            loading: false,
            error: false,
            message: null,
          });
        }, 6000);
      } else {
        toast.error(res.data.message);
      }
    } else {
      toast.error("Error while saving product, Please try again later");
    }
  }

  const validationOptions = {
    name: {
      required: true,
      minLength: 2,
      maxLength: 60,
      type: "alnum_with_spaces",
    },
    model_number: { required: true },
    version: { required: true },
    min_ad_price: { required: true },
  };

  useEffect(() => {
    const formChanged = has_changes();

    setDisableButton(formChanged);

    const imageCount = appData.productCount;
    if (imageCount !== appData.productImagesGlobal.length) {
      setDisableButton(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    initialState,
    initialStateCopy,
    validationOptions,
    appData.productImagesGlobal,
  ]);

  function has_changes() {
    const validation = Utils.validate(initialState, validationOptions);
    console.log(!validation[0] ,
      JSON.stringify(initialStateCopy) === JSON.stringify(initialState) ,
      JSON.stringify(longDescription) !== JSON.stringify(initialDescriptionAndImages.description) ,
      JSON.stringify(productImages) !== JSON.stringify(initialDescriptionAndImages.images));
    return (
      !validation[0] ||
      (JSON.stringify(initialStateCopy) === JSON.stringify(initialState) &&
      JSON.stringify(longDescription) === JSON.stringify(initialDescriptionAndImages.description) &&
      JSON.stringify(productImages) === JSON.stringify(initialDescriptionAndImages.images))

    );
  }
  function cancel_changes() {
    setLongDescription(initialDescriptionAndImages.description)
    setProductImages(initialDescriptionAndImages.images)
    return setinitialState(initialStateCopy);
  }

  function Initialise_form() {
    var form = {
      name: "",
      model_number: "",
      version: "",
      description: "",
      active: true,
      category_id: "",
      party_id: "",
      source: "1",
      image_flag: false,
      min_ad_price: 0,
      normalized_min_ad_price: 0,
      long_description: false,
      publication: 1,
      sku: "",
      parent_id: "",
      upc: "",
      channel: channelKey,
      stage_item_id: 0,
      product_attr_values: {
        add_attr_values: [],
        delete_attr_values: [],
      },
      product_attr_values_existing: [],
    };
    setinitialState(form);
    setinitialStateCopy(form);
  }

  useEffect(() => {
    if (categoryList && categoryList.length > 0) {
      if (productid === "0" && selected_Category.id === null) {
        const categoryId = new URLSearchParams(location.search).get('categoryid')
        const seletedCategory = categoryList.find(c => c.id === categoryId) ?? categoryList[0]
        setSelected_Category({
          id: seletedCategory.id,
          name: seletedCategory.name,
        });
      }
    }
  }, [categoryList, location]);

  useEffect(() => {
    Initialise_form();
    setRunMaster(true);
    if (productid !== "0") {
      load_Product_details_by_id();
    }
    // else {
      // appData.setProductImagesGlobal([])
   // }
  }, [productid]);

  const load_attributes = async (categoryId) => {
    try {
      setProduct_load_indicator((prev) => {
        return { ...prev, loading: true };
      });
      const res = await ServiceWrapper.doPost(
        `${api_base_url}get_attribute_values?page=${1}&limit=${1000}`,
        { category_id: categoryId },
        null,
        AuthManager.getGmsToken()
      );
      setProduct_load_indicator((prev) => {
        return { ...prev, loading: false };
      });
      if (!res.errorfound && res.data.data && res.data.data) {
        setAttributeList(res.data.data ?? []);
      } else {
        setAttributeList([]);
      }
    } catch (error) {
      setProduct_load_indicator((prev) => {
        return { ...prev, loading: false };
      });
      setAttributeList([]);
    }
  };
  
  useEffect(() => {
    if (Utils.isUndefinedOrNull(selected_Category.id)) return;
    if (Utils.isUndefinedOrNull(industryId)) return;
    if (productid === "0") Initialise_form();
    load_attributes(selected_Category.id);
  }, [selected_Category.id, industryId, channelKey]);

  useEffect(() => {
    if (Utils.isUndefinedOrNull(selectedAttvalues)) return;
    if (Utils.isUndefinedOrNull(selectedAttvalues.val)) return;
    var attributeid = selectedAttvalues.controlid;
    var att = attributeList.filter((i) => i.id === attributeid);
    if (att.length === 0) return;

    var itemp = JSON.parse(JSON.stringify(initialState));

    att[0].values.forEach((aval) => {
      var exists0 = itemp.product_attr_values_existing.filter(
        (i) => i.attributeid === attributeid && i.value === aval.id
      );
      var existed_in_original_List = exists0.length > 0;

      var exists1 = itemp.product_attr_values.add_attr_values.filter(
        (i) => i.attributeid === attributeid && i.value === aval.id
      );
      var existed_in_addList = exists1.length > 0;

      var exists2 = selectedAttvalues.val.filter(
        (i) => i.value === aval.id && i.value !== "*"
      );
      var existed_in_new_list = exists2.length > 0;

      if (existed_in_addList && !existed_in_new_list) {
        itemp.product_attr_values.add_attr_values =
          itemp.product_attr_values.add_attr_values.filter(
            (i) => i.value !== exists1[0].value
          );
        if (productid !== "0" && existed_in_original_List)
          itemp.product_attr_values.delete_attr_values.push(exists1[0]);
      } else if (!existed_in_addList && existed_in_new_list) {
        const nitem = {
          label: aval.value,
          value: aval.id,
          id: aval.id,
          attributeid: attributeid,
        };
        itemp.product_attr_values.add_attr_values.push(nitem);
        if (productid !== "0" && existed_in_original_List)
          itemp.product_attr_values.delete_attr_values.pop(nitem);
      }
    });

    var existsAll = selectedAttvalues.val.filter((i) => i.value === "*");
    var exists_all = existsAll.length > 0;
    var items_for_attributeid =
      itemp.product_attr_values.add_attr_values.filter(
        (i) => i.attributeid === attributeid
      );
    if (!existsAll) {
      existsAll = att[0].values.length === items_for_attributeid.length;
    }

    if (exists_all) {
      const nitem = {
        label: "All Selected",
        value: "*",
        id: "*",
        attributeid: attributeid,
      };
      itemp.product_attr_values.add_attr_values.push(nitem);
    } else {
      itemp.product_attr_values.add_attr_values =
        itemp.product_attr_values.add_attr_values.filter(
          (i) => !(i.value === "*" && i.attributeid === attributeid)
        );
    }

    itemp.product_attr_values.add_attr_values = _.sortBy(
      itemp.product_attr_values.add_attr_values,
      "label"
    );

    setinitialState(itemp);
  }, [selectedAttvalues]);

  function handleChange(e) {
    let value = e.target.value;
    if (e.target.name === "min_ad_price") {
      value = parseFloat(e.target.value);
    }
    setinitialState({ ...initialState, [e.target.name]: value });
  }

  function handleChecked(e) {
    setinitialState({
      ...initialState,
      [e.target.name]: e.target.checked,
    });
  }

  const onBackOrCancelClick = () => {
    history.goBack()
  }

  return (
    <>
      <div className="mb-2 d-flex justify-content-between">
        <div
          className="m-0 overflow-scroll container-fluid tw-text-center"          
        >
          {rulesRerun && (
            <RulesReRun
              rulesRerun={rulesRerun}
              setRulesRerun={setRulesRerun}
              catId={selected_Category.id}
            />
          )}
          {
            <>
              {!product_load_indicator.loading &&
                !product_load_indicator.error && (
                  <>
                    <div className="tw-text-center tw-align-middle ">
                      <div
                        className="mt-2"
                        style={{ float: "left", margin: 0 }}
                      >
                        <div 
                          className="tw-flex tw-items-center tw-gap-2.5"
                          onClick={onBackOrCancelClick}>
                            
                            <BackArrowIcon/>
                            <label className="tw-text-xl tw-font-semibold">{productid !== "0" ? initialState.name : "Create Product"}</label>
                            
                          </div>
                        {productid !== "0" && (
                          <div className="tw-justify-start tw-flex tw-ms-5" style={{ fontSize: "15px", width: "auto" }}>
                            <div>
                              <Label
                                message={"ID: " + productid}
                                fontSize={0.8}
                              />
                              &nbsp;&nbsp;
                              <Label
                                message={"Model: " + initialState.model_number}
                                fontSize={0.8}
                                color="#797979"
                                className="m-0"
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      <div
                        style={{ float: "right" }}
                        className="mt-2 align-self-center align-items-center d-flex tw-gap-3"
                      >
                        <GMSBorderlessButton
                          name="Reset"
                          onClick={() => {
                            cancel_changes();
                          }}
                          disabled={has_changes()}
                        />
                        <button
                          onClick={onBackOrCancelClick}
                            className="outline-button tw-w-max"
                        >
                        Cancel
                        </button>
                        
                        
                        <button
                          onClick={() => {
                            if (
                              AuthManager.getPermissions().gmsproducts_update
                            ) {
                              handleSaveEdit();
                            } else {
                              toast.info(
                                "You do not have permission to save the product"
                              );
                            }
                          }}
                          disabled={isSaving}
                          className="button-style tw-w-max disabled:tw-bg-primary-disabled disabled:tw-border-primary-disabled"
                        >
                        Save
                        </button>
                        
                      </div>
                    </div>
                  </>
                )}
            </>
          }
        </div>
      </div>
      {!product_load_indicator.loading &&
        !product_load_indicator.error && (
            <div className={`tw-box-border tw-w-auto tw-h-px tw-border-t-[1px] tw-border-solid tw-border-[#D1D1D6] tw-mt-1 tw-mb-2`} />  
        ) }
      
      {product_load_indicator.loading === true &&
        !product_load_indicator.error && (
          <div className="row d-flex justify-content-center">
            <div className="ps-4 col-8">
              <SkeletonElement type={"text50"} />

              <div className="mt-2 row">
                <div className="col-4">
                  <>
                    <SkeletonElement type={"text50"} />
                    <SkeletonElement type={"title"} />
                  </>
                </div>
                &nbsp;&nbsp;&nbsp;
                <div className="col-4">
                  <SkeletonElement type={"text50"} />

                  <SkeletonElement type={"title"} />
                </div>
                <div className="3"></div>
              </div>

              <div>
                <div className="mt-2 row">
                  <div>
                    <SkeletonElement type={"text50"} />
                    <SkeletonElement type={"title"} />
                  </div>
                </div>
                <div className="mt-2 row">
                  <div>
                    <SkeletonElement type={"text50"} />
                    <SkeletonElement type={"title"} />
                  </div>
                </div>
                <div className="mt-2 row">
                  <div className="col-4">
                    <SkeletonElement type={"text50"} />
                    <SkeletonElement type={"title"} />
                  </div>
                  <div className="col-4">
                    <SkeletonElement type={"text50"} />

                    <SkeletonElement type={"title"} />
                  </div>
                  <div className="col-4">
                    <SkeletonElement type={"text50"} />
                    <SkeletonElement type={"title"} />
                  </div>
                </div>
                <div className="mt-2 row">
                  <div className="col-4">
                    <SkeletonElement type={"text50"} />
                    <SkeletonElement type={"title"} />
                  </div>
                </div>
                <div className="mt-3 row ms-1">
                  <SkeletonElement type={"title"} />
                </div>
                <div className="mt-3 row ms-1">
                  <SkeletonElement type={"title"} />
                </div>
                <div className="mt-2 row">
                  <div className="col-12">
                    <div className="flex-wrap tw-flex tw-justify-content-start tw-gap-1">
                      {[1, 2, 3, 4, 5].map((singleAttribute, attrIndex) => {
                        return (
                          <div className="" key={singleAttribute}>
                            <SkeletonElement type={"text50"} />
                            <span>
                              <SkeletonElement type={"text"} />
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid vh-100"></div>
          </div>
        )}

      {!product_load_indicator.loading && !product_load_indicator.error && (
        <>
          <div className="row d-flex justify-content-center">
            <div className="ps-4 col-9">
              <label className="tw-text-base tw-font-semibold">Basic Details</label>

              <div className="mt-2 row">
                <div className="col-4">
                  <>
                    <label className="tw-tw-text-sm">Category</label>
                    <select
                      className="form-select input-box-style"
                      onChange={(e) => {
                        setSelected_Category({
                          id: e.currentTarget.value,
                          name: e.target.selectedOptions[0].text,
                        });
                      }}
                      value={selected_Category.id || 0}
                      disabled={productid !== "0"}
                    >
                      <option
                        value={null}
                        disabled={selected_Category.id !== null}
                      >
                        Select category from list
                      </option>
                      {categoryList.map((item, index) => {
                        return (
                          <option value={item.id} key={item.id || index}>
                            {item.name}
                          </option>
                        );
                      })}
                    </select>
                  </>
                </div>
                {/* &nbsp;&nbsp;&nbsp; */}
                {selected_Category.id !== null && (
                  <div className="col-4">
                    
                    <label className="tw-text-sm">UPC</label>
                    <input
                      type="number"
                      className="form-control input-box-style"
                      
                      id="upc"
                      name="upc"
                      value={initialState.upc}
                      onChange={handleChange}
                      placeholder="upc"
                    />
                  </div>
                )}

                <div className="3"></div>
              </div>
              {selected_Category.id !== null && (
                <div>
                   {productid === "0" ? (
                    <div className="mt-2 row">
                      <div className="col-4">
                        <label className="tw-text-sm">SKU<span className="tw-text-danger">*</span></label>
                        <input
                          type="text"
                          className={`form-control input-box-style ${
                            formSubmitted && (!initialState.sku || initialState.sku === '')
                              ? 'border-danger'
                              : ''
                          }`}
                          id="sku"
                          name="sku"
                          value={initialState.sku}
                          onChange={handleChange}
                          placeholder="sku"
                        />
                      </div>
                      <div className="col-4">
                        <label className="tw-text-sm">Parent ID<span className="tw-text-danger">*</span></label>
                        <input
                          type="text"
                          className={`form-control input-box-style ${
                            formSubmitted && (!initialState.parent_id || initialState.parent_id === '')
                              ? 'border-danger'
                              : ''
                          }`}
                          id="parent_id"
                          name="parent_id"
                          value={initialState.parent_id}
                          onChange={handleChange}
                          placeholder="Parent ID"
                        />
                      </div>
                    </div>
                  ): null}
                  <div className="mt-2 row">
                    <div>
                      <label className="tw-text-sm">Name<span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className={`form-control input-box-style ${
                          formSubmitted && (!initialState.name || initialState.name === '')
                            ? 'border-danger'
                            : ''
                        }`}
                        id="floatingInput"
                        name="name"
                        value={initialState.name}
                        onChange={handleChange}
                        placeholder="Enter name of the product"
                      />
                      <div id="nameHelp" className="form-text">
                        <Label
                          message=""
                          fontSize={0.7}
                          fontWeight="600"
                          color="#B0B0B0"
                        />
                        <label className="tw-text-sm ">{NAME_INFO}</label>
                      </div>
                    </div>
                  </div>
                  <div className="mt-2 row">
                    <div>
                      <label className="tw-text-sm">Description</label>
                      <textarea
                        type="textaria"
                        className="form-control input-box-style"
                        id="floatingInput"
                        name="description"
                        value={initialState.description}
                        onChange={handleChange}
                        placeholder="Enter description of the product"
                      />
                    </div>
                  </div>
                  <div className="mt-2 row">
                    <div className="col-4">
                    <label className="tw-text-sm">Model Number<span className="tw-text-danger">*</span></label>                    
                      <input
                        type="text"
                        className={`form-control input-box-style ${
                          formSubmitted && (!initialState.model_number || initialState.model_number === '')
                            ? 'border-danger'
                            : ''
                        }`}
                        id="model_number"
                        name="model_number"
                        onChange={handleChange}
                        value={initialState.model_number}
                        placeholder="Model number for product"
                      />
                    </div>
                    <div className="col-4">
                      <label className="tw-text-sm">Version<span className="tw-text-danger">*</span></label>

                      <input
                        type="text"
                        className={`form-control input-box-style ${
                          formSubmitted && (!initialState.version || initialState.version === '')
                            ? 'border-danger'
                            : ''
                        }`}
                        id="model_number"
                        name="version"
                        onChange={handleChange}
                        value={initialState.version}
                        placeholder="version of product"
                      />
                    </div>
                    <div className="col-4">

                      <label className="tw-text-sm">Min AD Price<span className="tw-text-danger">*</span></label>
                      <input
                        type="number"
                        className={`form-control input-box-style ${
                          formSubmitted && !initialState.min_ad_price || initialState.min_ad_price === ''
                            ? 'border-danger'
                            : ''
                        }`}
                        id="min_ad_price"
                        name="min_ad_price"
                        value={Utils.round(initialState.min_ad_price)}
                        onChange={handleChange}
                        placeholder="min_ad_price"
                      />
                    </div>
                  </div>
                  <div className="mt-2 row">
                    <div className="col-4">
                      <label className="tw-text-sm">Normalized Min AD Price</label> 
                      <input
                        type="number"
                        className="form-control input-box-style"
                        style={{
                          fontSize: "0.875rem",
                          fontWeight: "400",
                        }}
                        id="normalized_min_ad_price"
                        name="normalized_min_ad_price"
                        value={
                          isNaN(initialState?.normalized_min_ad_price)
                            ? Utils.round(initialState.normalized_min_ad_price)
                            : "-"
                        }
                        onChange={handleChange}
                        placeholder="min_ad_price"
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="mt-3 row">
                    <ProductImages productID={productid} 
                      productImages={productImages}
                      setProductImages={setProductImages}
                      setInitialDescriptionAndImages={setInitialDescriptionAndImages}
                    />
                  </div>
                  <div className="mt-3 row">
                    <LongDescription
                      longDescription={longDescription}
                      setLongDescription={setLongDescription}
                      productID={productid}
                      productDescriptionAvailable={productDescriptionAvailable}
                      setInitialDescriptionAndImages={setInitialDescriptionAndImages}
                    />
                  </div>
                  <div className="mt-3 row">
                    <div className="col-12">
                      <div className="flex-wrap gap-1 d-flex justify-content-start">
                        {attributeList &&
                          attributeList.length > 0 &&
                          attributeList.map((singleAttribute, attrIndex) => {
                            var values = singleAttribute.values.map(
                              (val, vindex) => {
                                val = {
                                  label: val.value,
                                  value: val.id,
                                  id: val.id,
                                  attributeid: singleAttribute.id,
                                };
                                return val;
                              }
                            );
                            let selectedvalues = [];
                            selectedvalues =
                              initialState &&
                              initialState.product_attr_values &&
                              initialState.product_attr_values.add_attr_values.filter(
                                (attr) =>
                                  attr.attributeid === singleAttribute.id
                              );

                            return (
                              <div className="" key={singleAttribute.id}>
                                <label className="text-[#6B778C] text-base font-medium p-1">
                                {singleAttribute.name}
                                </label>
                                <span>
                                  <MultiSelectAll
                                    options={values}
                                    // setSelectedOptions={setSelectedOptions}
                                    selectedOptions={selectedvalues}
                                    controlid={singleAttribute.id}
                                    callback={setSelectedAttvalues}
                                  />
                                </span>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="container-fluid vh-100"></div>
          </div>
        </>
      )}
    </>
  );
}

export default CreateEditProduct;